<template>
    <div id="content">
        <div :class="screen == 'list' ? 'container' : ''">
            <div id="page-header-fixed" class="mb-20">
                <div class="container">
                    <div id="page-header">
                        <ul class="breadcrumb">
                            <li class="icon">
                                <a @click="$router.go(-1)">
                                    <img src="/themes/ito/images/back-to.svg" alt="">
                                </a>
                            </li>
                            <li class="active">{{ unit_name }} - {{ lesson_name }}: {{ lesson_detail }} </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="mark-lesson" v-if="screen != 'list'" @click="handleFocusOut"></div>
            <div class="card" style="overflow: inherit;" :class="screen != 'list' ? 'box-leson' : ''">

                <div class="mark-dropdown" v-if="show_next_item" @click="handleFocusOut">
                    <div class="menu-next-item" v-if="show_next_item">
                        <li @click="nextItem" v-if="(next != '' && next != undefined)">
                            <img v-if="next.type == 'vocabulary'" src="/themes/ito/images/lession-item1.png" style="height:22px; margin-right:5px;">
                            <img v-if="next.type == 'lecture'" src="/themes/ito/images/lession-item2.png" style="height:22px; margin-right:5px;">
                            <img v-if="next.type == 'practice'" src="/themes/ito/images/lession-item3.png" style="height:22px; margin-right:5px;">
                            <img v-if="next.type == 'handouts'" src="/themes/ito/images/pdf.svg" style="height:22px; margin-right:5px;">
                            {{ (next != '' && next != undefined) ? $t('go_to') + " " + $t(next.type) : $t('go_to_next_item')
                            }}
                        </li>
                        <li @click="gotoWave" v-else>{{ (next != '' && next != undefined) ? $t('go_to') + " " +
                            $t(next.type) :
                            'Go to next item' }}</li>
                        <hr />
                        <li @click="gotoWave"><img src="/themes/ito/images/close1.svg" style="height:22px; margin-right:5px; margin-left: 5px">{{ $t('quit') }}</li>
                    </div>
                </div>
                <div class="card-body" v-if="screen == 'list'">
                    <div class="wave-lesson">
                        <div class="waves" :class="items_length < 6 ? 'min-100' : ''">
                            <template v-for="(item, index) in items">
                                <div class="item-wave-lesson">
                                    <div class="item-wave-lesson-inner" @click="detailLessonOpen(item.id, item.type)">
                                        <div class="rating-crown" v-if="item.type == 'practice'">
                                            <template v-for="i in 3">
                                                <img src="/themes/ito/images/icon-crown.svg" v-if="item.star >= i">
                                                <img src="/themes/ito/images/icon-crown-disable.svg" v-else>
                                            </template>
                                        </div>
                                        <img src="/themes/ito/images/lession-item1.png" v-if="item.type == 'vocabulary'">
                                        <img src="/themes/ito/images/lession-item2.png" v-if="item.type == 'lecture'">
                                        <img src="/themes/ito/images/lession-item3.png" v-if="item.type == 'practice'">
                                        <img src="/themes/ito/images/pdf.svg" v-if="item.type == 'handouts'">

                                        <div class="item-wave-lesson-text">
                                            {{ $t(item.type) }}
                                            <template v-if="item.type != 'handouts'">
                                                <i class="ito-icon-checked" v-if="item.complete == 1"></i>
                                                <i class="ito-icon-checked-disable" v-else></i>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="wave-lesson-bottom">
                        <div style="margin: 0 25px; font-size: 15px">
                            <i class="ito-icon-checked-disable"></i> {{ $t('incomplete') }}
                        </div>
                        <div style="margin: 0 25px; font-size: 15px">
                            <i class="ito-icon-checked"></i> {{ $t('complete') }}
                        </div>
                    </div>
                </div>

                <div class="card-body vocabulary" v-if="screen == 'vocabulary'">
                    <div class="lesson-action-button vocabulary" @click="showMenuItem"><span>+</span></div>
                    <div class="card-content" style="height: calc(100% - 10px); padding: 0;">
                        <iframe :src="item.content" allow="microphone; camera; autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture; web-share"
                            sandbox="allow-same-origin allow-scripts allow-forms allow-popups **allow-modals** allow-presentation allow-downloads" width="100%" height="100%" frameborder="0" allowfullscreen>
                        </iframe>

                    </div>
                </div>

                <div class="card-body" v-if="screen == 'lecture'">
                    <div class="lesson-action-button" @click="showMenuItem"><span>+</span></div>
                    <div class="card-title p-0">
                        <p class="title">{{ $t('lecture') }}</p>
                    </div>
                    <div class="card-content p-0" style="height: calc(100% - 52px);">
                        <iframe width="100%" height="100%" :src="item.content" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>

                <div class="card-body" v-if="screen == 'practice'">
                    <div class="lesson-action-button" @click="showMenuItem"><span>+</span></div>
                    <div class="card-content" style="height: 100%; padding: 0;">
                        <iframe :src="item.content" frameborder="0" allowfullscreen width="100%" height="100%" scrolling="no"></iframe>

                    </div>
                </div>

                <div class="card-body" v-if="screen == 'handouts'">
                    <div class="lesson-action-button" @click="showMenuItem"><span>+</span></div>
                    <div class="card-content" style="height: 100%; padding: 0;">
                        <iframe :src="item.content" frameborder="0" allowfullscreen width="100%" height="100%"></iframe>
                    </div>
                </div>
            </div>

            <div class="modal fade reward-popup" id="rewardPopup" tabindex="-1" role="dialog" aria-labelledby="rewardPopup" aria-hidden="true" data-bs-backdrop="static" data-keyboard=false>
                <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 330px;">
                    <div class="modal-content box-shadow-main paymment-status">
                        <div class="close-popup" data-bs-dismiss="modal" @click="gotoWave(false)"></div>
                        <h3 class="popup-title success">{{ $t('completed_practice') }}</h3>
                        <div class="list-item-result-popup">
                            <div class="item-result-popup" :class="crown > 0 ? 'active' : ''"></div>
                            <div class="item-result-popup" :class="crown > 1 ? 'active' : ''"></div>
                            <div class="item-result-popup" :class="crown > 2 ? 'active' : ''"></div>
                        </div>
                        <div class="box-result-popup d-flex justify-content-center">
                            <div class="result">
                                <div class="result-txt">{{ $t('you_answered_correctly') }}</div>
                                <div class="result-score"><span class="score">{{ correct }}</span>/<span class="total">{{
                                    total
                                        }}</span> </div>
                            </div>
                            <div class="gem-reward" v-if="gem > 0">
                                <div class="text-bold">+{{ gem }} </div>
                                <AppIcon class="m-0" :src="$store.state.gem_icon_url" :size="15" />
                            </div>

                        </div>
                        <button class="next-item-modal" v-if="(next != '' && next != undefined)" @click="nextItem" data-bs-dismiss="modal" aria-label="Close">{{ (next != '' && next != undefined) ? $t('go_to') +
                            " "
                            +
                            $t(next.type) : $t('close') }}</button>
                    </div>
                </div>
            </div>

            <div id="modalVocabSuccess" class="modal fade modal-flex" tabindex="-1" role="dialog" style="text-align: center">
                <div class="modal-dialog modal-sm" role="document">
                    <div class="modal-content">
                        <i class="ito-icon-close modal-close" data-bs-dismiss="modal" aria-label="Close"></i>
                        <div class="modal-body">
                            <h4 class="title">{{ $t('congratulations') }}</h4>

                            <img src="/themes/ito/images/get-rewarded.svg" alt="">
                            <p class="mt-2">{{ $t('completed_vocabulary_lesson') }}</p>
                            <button class="next-item-modal" v-if="(next != '' && next != undefined)" @click="nextItem" data-bs-dismiss="modal" aria-label="Close">{{ (next != '' && next != undefined) ?
                                $t('go_to') +
                                " " + $t(next.type) : $t('close') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <star-rating-popup v-if="show_survey" logo="/themes/ito/images/logo.svg" :api-url="api_survey" :token="token" app-code="ipro" />
    </div>
</template>

<script>
import axios from "axios";
import { getUnitLessonDetail, getUnitLessonItem, getItemInfo } from "../../models/dashboard";
import AppIcon from "@/components/common/AppIcon.vue";

export default {
    name: "LessonDetail",
    title: 'Lesson detail',
    components: { AppIcon },
    props: [
        'user_info'
    ],
    computed: {
        user() {
            return this.$store.state.user_info;
        },
    },
    data() {
        return {
            isLoading: false,
            items: [],
            unit_id: this.$route.params.unit_id,
            lesson_id: this.$route.params.lesson_id,
            unit_name: '',
            lesson_name: '',
            lesson_detail: '',
            item: {},
            screen: 'list',
            correct: 0,
            total: 0,
            crown: 0,
            gem: 0,
            current_item: 0,
            next: '',
            show_next_item: false,
            items_length: 0,
            page_title: "Lesson detail",
            api_survey: process.env.VUE_APP_API_SURVEY,
            token: localStorage.getItem('access_token') || '',
            show_survey: false
        };
    },

    async created() {
        await this.getUnitLessonDetail()
        // if (!this.item) return

        // window.addEventListener("message", async (event) => {
        //     switch (event.data.type) {
        //         case 'update_item_info':
        //             await getItemInfo({
        //                 id: this.item.id,
        //                 item_type: this.item.type,
        //             });
        //     }
        // }, {once: true});
    },
    mounted() {
        window.addEventListener('message', this.handleMessage)
        window.addEventListener('message', this.handleUpgradeFeature);
    },
    updated() {
        document.title = this.page_title;
        const slider = document.querySelector('.wave-lesson');
        let isDown = false;
        let startX;
        let scrollLeft;
        if (slider) {
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 1; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });
        }
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage)
        window.removeEventListener('message', this.handleUpgradeFeature);
        window.boChatbot?.deleteContext('module')
    },
    watch: {
        'item': function (newVal, oldVal) {
            if (newVal) {
                const that = this;
                let index = this.items.findIndex(x => x.id == newVal.id);
                that.current_item = index;
                let array_next = [];
                for (let i = 0; i < that.items.length; i++) {
                    if (i < that.current_item && that.items[i].complete == 0) {
                        array_next.push(i);
                    }
                    that.next = that.items[array_next[0]];
                    if (i > that.current_item) {
                        if (that.items[i].complete == 0) {
                            that.next = that.items[i];
                            break;
                        } else {
                            if (array_next[0]) {
                                that.next = that.items[array_next[0]];
                                break;
                            }
                            else {
                                that.next = '';
                            }
                        }
                    }
                }
            }
        }
    },
    methods: {
        handleFocusOut(e) {
            this.show_next_item = false;
        },
        nextItem() {
            this.show_next_item = false;
            let id = this.next.id;

            const that = this;
            that.isLoading = true;

            axios.all([
                getUnitLessonItem(id),
            ]).then(axios.spread((response) => {
                that.isLoading = false;

                if (response.data.code != 0) {
                    return;
                }

                that.item = response.data.results.item;
                that.unit_name = response.data.results.name_unit;
                that.lesson_name = response.data.results.name_lesson;
                that.lesson_detail = response.data.results.title_lesson;
                // that.lesson_type = response.data.results.item.type;
                that.screen = response.data.results.item.type;
            }));
        },
        async handleMessage(event) {
            const that = this;
            if (!this.item) return;

            switch (event.data.type) {
                case 'update_item_info':
                    const response = await getItemInfo({
                        id: this.item.id,
                        item_type: this.item.type,
                    })

                    if (response.data.code != 0) {
                        return;
                    }
                    that.user.dailychallenge_noti = response.data.results.dailychallenge_noti || 0;
                    that.user.count_achieve_unread = response.data.results.count_achieve_unread || 0;
                    if (this.item.type == 'practice') {
                        this.correct = response.data.results.current_result.correct_quest;
                        this.total = response.data.results.current_result.total_quest;
                        this.crown = response.data.results.current_result.crown;
                        this.gem = response.data.results.gem_reward;
                        $('#rewardPopup').modal('show');
                    }
                    if (this.item.type == 'vocabulary') {
                        $('#modalVocabSuccess').modal('show');
                    }
                    await this.getUnitLessonDetail();
                    break;

                case 'update_items':
                    window.boChatbot?.setContext('module', {
                        type: this.screen,
                        data: event.data.data
                    })
            }
        },
        handleUpgradeFeature(event) {
            if (event.data === 'upgrade_ai_speak') {
                this.$router.push(`/upgrade-feature?feature_code=speak_ai_attempt`);
            }
            if (event.data === 'upgrade_package') {
                this.$router.push(`/upgrade-account`);
            }
        },
        showMenuItem() {
            if (this.show_next_item == true) {
                this.show_next_item = false;
            } else {
                if (this.next == '' || this.next == undefined) {
                    this.screen = 'list';
                    this.show_next_item = false;
                    this.$store.commit("setShowEffect", true);
                    getItemInfo({
                        id: this.item.id,
                        item_type: this.item.type,
                    });
                } else {
                    this.show_next_item = true;
                }
            }
        },
        gotoWave(isGetItemInfo = true) {
            this.screen = 'list';
            this.show_next_item = false;
            this.$store.commit("setShowEffect", true);
            if (!isGetItemInfo) return

            getItemInfo({
                id: this.item.id,
                item_type: this.item.type,
            });

            this.show_survey = true
        },

        async getUnitLessonDetail() {
            const that = this;

            const { subject_id, unit_id, lesson_id } = that.$route.params;

            that.isLoading = true;

            const response = await getUnitLessonDetail(subject_id, unit_id, lesson_id)

            that.isLoading = false;

            if (response.data.code != 0) {
                return;
            }

            that.items = response.data.results.item;
            that.items_length = that.items.length;
            that.unit_name = response.data.results.name_unit;
            that.lesson_name = response.data.results.name_lesson;
            that.lesson_detail = response.data.results.title_lesson;
            that.page_title = that.unit_name + " - " + that.lesson_name + " : " + that.lesson_detail;

            // window.boChatbot?.changeSubjectByName(response.data.results.title_unit)
            // window.boChatbot?.changeTopicByName(response.data.results.title_lesson)
            window.boChatbot?.setContext('unit', response.data.results.title_unit)
            window.boChatbot?.setContext('lesson', response.data.results.title_lesson)
        },
        detailLessonOpen(id, type) {
            var event = ''
            const that = this;
            that.isLoading = true;
            this.$store.commit("setShowEffect", false);
            switch (type) {
                case 'vocabulary':
                    event = 'IP1_W_3000';
                    break;
                case 'lecture':
                    event = 'IP1_W_3001';
                    break;
                case 'practice':
                    event = 'IP1_W_3002';
                    break;
                case 'handouts':
                    event = 'IP1_W_3004';
                    break;
                default:
                    event = '';
                    break;
            }
            this.handleGACustomEvent(event, id);
            axios.all([
                getUnitLessonItem(id),
            ]).then(axios.spread((response) => {
                that.isLoading = false;

                if (response.data.code != 0) {
                    return;
                }

                that.item = response.data.results.item;
                that.unit_name = response.data.results.name_unit;
                that.lesson_name = response.data.results.name_lesson;
                that.lesson_detail = response.data.results.title_lesson;
                // that.lesson_type = response.data.results.item.type;
                that.screen = response.data.results.item.type;

                window.boChatbot?.setContext('module', {
                    type: that.screen
                })
            }));
        },
        testHandouts(id, type) {
            const that = this;
            that.isLoading = true;
            that.item = {
                "id": 3169,
                "name": "vocabulary",
                "content": "https://dev-lcms.dreamlab.com.vn/handouts",
                "type": "vocabulary",
                "complete": 1,
                "star": 0,
                "attemp": null
            }
            that.unit_name = "Unit 1";
            that.lesson_name = "Lesson 1";
            that.screen = 'vocabulary';
            // axios.all([
            //     getUnitLessonItem(id),
            // ]).then(axios.spread((response) => {
            //     that.isLoading = false;
            //
            //     if (response.data.code != 0) {
            //         return;
            //     }
            //
            //     that.item = response.data.results.item;
            //     that.unit_name = response.data.results.name_unit;
            //     that.lesson_name = response.data.results.name_lesson;
            //     // that.lesson_type = response.data.results.item.type;
            //     that.screen = 'vocabulary';
            // }));
        },
        handleGACustomEvent(element, item_id) {
            var params = {
                'w_user_id': this.user.user_id,
                'item_id': item_id
            }
            params[element] = this.user.user_id + '|' + item_id
            gtag('event', element, params)
        }
    }
}
</script>

<style scoped>
#page-header .breadcrumb {
    margin-bottom: 0;
}

.wave-lesson {
    position: relative;
    height: 550px;
    display: flex;
    width: 100%;
    align-items: center;
    overflow: auto;
    user-select: none;
    cursor: grab;
    cursor: -webkit-grab;
}

.wave-lesson::-webkit-scrollbar {
    width: 14px;
    height: 14px;
}

.wave-lesson::-webkit-scrollbar-thumb {
    border: 3px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 9999px;
    background-color: #aaaaaa;
    opacity: 0.4;
    transition: background-color 0.5s ease;
}

.wave-lesson::-webkit-scrollbar-thumb:hover {
    opacity: 1;
}

.wave-lesson::-webkit-scrollbar-thumb:hover {
    background-color: #888;
}

.wave-lesson.active {
    cursor: grabbing;
    cursor: -webkit-grabbing;
}

.waves {
    background: url(/public/images/loop.svg) no-repeat;
    background-position: left;
    display: flex;
    padding: 0 60px;
}

.item-wave-lesson {
    display: flex;
    width: 178px;
    text-align: center;
    justify-content: center;
}

.item-wave-lesson-inner {
    height: fit-content;
    cursor: pointer;
}

.item-wave-lesson:nth-child(2n + 1) .item-wave-lesson-inner {
    margin-top: -40px;
}

.item-wave-lesson:nth-child(2n) .item-wave-lesson-inner {
    margin-top: 140px;
}

.item-wave-lesson-text {
    font-size: 16px;
    font-weight: 700;
    color: #1E263C;
    margin-top: 8px;
}

.rating-crown {
    width: 86px;
    height: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
}

.rating-crown img {
    width: 19px;
    height: 18px;
}


.wave-lesson-bottom {
    position: absolute;
    width: 356px;
    height: 40px;
    background: #F5F5F5;
    border-radius: 16px 16px 0 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.lesson-action-button {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0 7px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    background: #F04821;
    cursor: pointer
}

.lesson-action-button span {
    display: block;
    width: 26px;
    height: 26px;
    margin: 13px auto;
    background: #ffffff;
    text-align: center;
    color: #f04821;
    font-size: 26px;
    line-height: 26px;
    font-weight: bold;
    border-radius: 100%;
    transform: rotate(45deg);
}

.menu-next-item {
    position: absolute;
    width: 200px;
    min-width: fit-content;
    height: 100px;
    right: 5px;
    top: 57px;
    border: 1px solid #dfdfdf;
    border-radius: 10px;
    box-shadow: 4px 4px 0px 0px #00000012;
    background: #fff;
    z-index: 100;
    padding: 0px 20px;
    animation-name: menu-next-item;
    animation-duration: .2s;
}

@keyframes menu-next-item {
    from {
        top: 40px;
        opacity: 0%;
    }

    to {
        top: 57px;
        opacity: 100%;
    }
}

.menu-next-item li {
    cursor: pointer;
    list-style: none;
    display: flex;
    height: 50%;
    width: 100%;
    align-items: center;
    justify-content: start;
    font-size: 15px;
    font-weight: 600;
}

.menu-next-item hr {
    border: none;
    margin: 0;
}

.mark-lesson {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    left: 0;
    right: 0;
    top: 0;
    z-index: 1000;
}

.modal-sm {
    max-width: 400px;
}

.ito-icon-close {
    position: absolute;
    right: 18px;
}

.next-item-modal {
    background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
    border-radius: 20px;
    box-shadow: 4px 4px 0px 0px #00000012;
    border: none;
    padding: 5px 10px;
    color: #fff;
    margin-top: 10px;
}

.box-result-popup {
    padding: 8px 15px;
}

.min-100 {
    min-width: 100%;
}

.box-leson {
    position: fixed;
    width: 98%;
    height: 96vh;
    left: 1%;
    top: 2vh;
    z-index: 1001;
}

.card-title .title {
    font-family: 'Nunito';
    font-style: normal;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    padding: 14px 30px;
}

.result {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.gem-reward {
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #C4C4C4;
}
</style>